import axios from "axios";
import i18n from "../../../../i18n";

const initialState = {};

export const introductionReducer = (state = initialState, action) => {
  return state;
};

export const submitBirthDate = (params) => (dispatch, getState) => {
  return axios
    .post(`/api/participant/birthdate`, params)
    .then(() => {
      return Promise.resolve(i18n.t("appText.introduction.post.success"));
    })
    .catch((e) => {
      return Promise.reject(
        e?.response?.data ?? i18n.t("appText.introduction.post.error")
      );
    });
};

export const mapDispatchToProps = {
  submitBirthDate,
};
